var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M1.00029 6.86078C2.91669 11.0347 6.32669 14.3532 10.5662 16.1522L11.2458 16.455C12.8006 17.1477 14.6284 16.6214 15.5767 15.2079L16.4648 13.8842C16.7536 13.4538 16.6656 12.8742 16.2623 12.5488L13.2504 10.119C12.8081 9.76208 12.1575 9.84521 11.8191 10.3019L10.8874 11.5591C8.49658 10.3798 6.55553 8.43873 5.37619 6.04792L6.63344 5.1162C7.0901 4.77778 7.17323 4.12727 6.81634 3.68489L4.38647 0.672942C4.06112 0.269661 3.48162 0.181693 3.05125 0.470262L1.71841 1.36396C0.296069 2.31767 -0.227312 4.16052 0.48142 5.71947L0.999509 6.85908L1.00029 6.86078Z"}));
}

Phone.defaultProps = {"width":"17","height":"17","fill":"none","viewBox":"0 0 17 17"};

module.exports = Phone;

Phone.default = Phone;
